import { createApp } from '@backstage/frontend-defaults';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import consolePlugin from '@internal/plugin-console';
import { themeModule } from './modules/theme';
import { signInModule } from './modules/signin';
import { navModule } from './modules/nav';

export default createApp({
  features: [
    consolePlugin,
    userSettingsPlugin,
    themeModule,
    signInModule,
    navModule,
  ],
});
